import Vue from 'vue'
import Router from 'vue-router'
import main from '@/views/index'
import loginPage from '@/views/login/index'  //登录
import homePage from '@/views/home/homePage'  //首页
// 审核管理
// 入驻审核
import designerEnter from '@/views/auditManagement/enterAudit/designerEnter'  //设计师入驻
import facilitatorEnter from '@/views/auditManagement/enterAudit/facilitatorEnter'  //服务商入驻
import merchantEnter from '@/views/auditManagement/enterAudit/merchantEnter'  //商家入驻
// 打印审核
import materialsAudit from '@/views/auditManagement/printAudit/materialsAudit'  //材料审核
import serverAudit from '@/views/auditManagement/printAudit/serverAudit'  //服务审核
import productAudit from '@/views/auditManagement/printAudit/productAudit'  //成品审核
// 设计审核
import demandAudit from '@/views/auditManagement/designAudit/demandAudit'  //需求审核
import modelAudit from '@/views/auditManagement/designAudit/modelAudit'  //模型审核
import worksAudit from '@/views/auditManagement/designAudit/worksAudit'  //成果审核
import designAudit from '@/views/auditManagement/designAudit/designAudit'  //平面设计审核

//商品审核
import goodsAudit from '@/views/auditManagement/goodsAudit/goodsAudit'  //需求审核

//用户管理
import userManager from '@/views/userManager/userManager'
import userStaff from '@/views/userManager/userStaff'
import userEnterprise from '@/views/userManager/userEnterprise';

//评价管理
import evaluationManagement from '@/views/evaluationManagement/evaluationManagement'
//订单管理
import printOrderList from '@/views/orderManagement/printOrderList'   //打印订单
import printOrderDetails from '@/views/orderManagement/printOrderDetails'   //打印订单详情
import mallOrderList from '@/views/orderManagement/mallOrderList'   //商城订单
import mallOrDetails from '@/views/orderManagement/mallOrDetails'   //商城订单详情
import designOrderList from '@/views/orderManagement/designOrderList'   //设计订单
import designOrderDetail from '@/views/orderManagement/designOrderDetail'   //设计订单
import modelOrderList from '@/views/orderManagement/modelOrderList'   //模型订单
import modelOrderDetails from '@/views/orderManagement/modelOrderDetails'   //模型订单详情
import severOrderList from '@/views/orderManagement/severOrderList'   //服务订单
import serverOrderDetails from '@/views/orderManagement/serverOrderDetails'   //服务订单
// import softwareOrderList from '@/views/orderManagement/softwareOrderList'   //软件订单
// import softwareOrderDetails from '@/views/orderManagement/softwareOrderDetails'   //软件订单详情
import designOrderList1 from '@/views/orderManagement/designOrderList1'   //平台垫付订单
import designOrderDetail1 from '@/views/orderManagement/designOrderDetail1'   //平台垫付订单
// 申诉管理
import complaintManagement from '@/views/complaints/complaintManagement'   // 申诉管理


// 活动管理
import activityManagement from '@/views/activityManagement/activityManagementList'
import signManagement from '@/views/activityManagement/signManagementList' // 报名管理
import worksManagement from '@/views/activityManagement/worksManagementList' // 全部作品
import awardManagement from '@/views/activityManagement/awardManagementList' // 获奖作品
import workReview from '@/views/activityManagement/workReviewList' // 作品审核
import judgesManagement from '@/views/activityManagement/judgesManagementList' // 评委管理
import leadershipManagement from '@/views/activityManagement/leadershipManagementList' // 领导管理
import leadershipLibraryList from '@/views/activityManagement/leadershipLibraryList' // 领导库
import judgesLibraryList from '@/views/activityManagement/judgesLibraryList' // 评委库
import activityTemplate from '@/views/activityManagement/activityTemplateList' // 模板库
import activityTemplateStyle from '@/views/activityManagement/activityTemplateStyleList' // 皮肤库
import activityMatchList from '@/views/activityManagement/activityMatchList'//活动比赛

//设计师级别管理
import designerLevelList from '@/views/designerLevelManager/designerLevelList'  // 设计师级别维护

//服务商上架下架
import shopProviders from '@/views/shopManager/shopProviders'
// 商家管理上架下架
import shopSettled from '@/views/shopManager/shopSettled'
//设计师管理
import designerManage from '@/views/shopManager/designerManage'

import contractorManager from '@/views/shopManager/contractorManager'

// 商品管理
import categoryManagement from '@/views/commodityManagement/category/categoryManagementList' // 商品分类管理
import category3D from '@/views/commodityManagement/category/category3D' // 商品类目管理-3D打印机
import marketManagement from '@/views/commodityManagement/marketManagement' // 商品营销管理
import category3DRecommend from '@/views/commodityManagement/category/category3DRecommend' // 商品推荐管理
import shelveGoodsManagement from '@/views/commodityManagement/shop/shelveGoodsList' // 上架商品管理
// 管理菜单
// import logManage from '@/views/logManage/logManage'   //日志管理菜单
import sysOperLogList from '@/views/logManage/sysOperLogList'   //日志管理菜单
import integralTi from '@/views/logManage/integralTi'   //积分体系管理
import integralSh from '@/views/logManage/integralSh'   //积分商品管理
import integralPay from '@/views/logManage/integralPay'   //积分交易管理
// 集采管理
import collectActiveMage from '@/views/collectManage/collectActiveMage'   //集采活动管理
import collectActiveStore from '@/views/collectManage/collectActiveStore'   //集采活动店铺
import collectGoodsAudit from '@/views/collectManage/collectGoodsAudit'   //集采商品审核
import collectGoodsMage from '@/views/collectManage/collectGoodsMage'   //集采商品管理
import collectOrderMage from '@/views/collectManage/collectOrderMage'   //集采订单管理
import collectOrderDetails from '@/views/collectManage/collectDialog/collectOrderDetails'   //集采订单管理详情页

//小程序管理
import appletOrder from '@/views/applet/appletOrderList'
import appletInvoice from '@/views/applet/appletInvoiceList'
import appletCase from '@/views/applet/appletCaseList'
import appletExplain from '@/views/applet/appletExplainList'
import appletAbout from '@/views/applet/appletAboutList'
import appletMessage from '@/views/applet/appletMessageList'
//砂芯
import appletOrderSx from '@/views/appletSx/appletOrderList'
import appletInvoiceSx from '@/views/appletSx/appletInvoiceList'
import appletCaseSx from '@/views/appletSx/appletCaseList'
import appletExplainSx from '@/views/appletSx/appletExplainList'
import appletAboutSx from '@/views/appletSx/appletAboutList'
import appletMessageSx from '@/views/appletSx/appletMessageList'
//圈子管理
import circleManager from '@/views/circle/circleManager'
import circleAudit from '@/views/circle/circleAudit'
// 创客圈管理
import dynamicAudit from '@/views/dynamic/dynamicAudit'
import commissionSet from '@/views/commission/commissionSet'

//设计师折扣设置
import discountSetting from '@/views/discountSetting/discountSetting'
//服务商折扣设置
import serviceDiscountSetting from '@/views/discountSetting/serviceDiscountSetting'

// 积分管理
import integralActivitylManagement from '@/views/integral/integralActivitylManagement'  // 活动管理
import integralActivitylStore from '@/views/integral/integralActivitylStore'  // 活动店铺
import integralGoodslManagement from '@/views/integral/integralGoodslManagement'  // 积分商品管理
import merchantsIntegralManagement from '@/views/integral/merchantsIntegralManagement'  // 商家积分管理
import userIntegralManagement from '@/views/integral/userIntegralManagement'  // 用户积分管理
import integralOrderManagement from '@/views/integral/integralOrderManagement'  // 积分订单管理
import integralOrderDetails from '@/views/integral/integralDialog/integralOrderDetails'  // 积分订单详情
import  systemLoginLog from '@/views/logManage/systemLoginLog'   //登录日志管理菜单

import  loginLogAnalyse from '@/views/logManage/loginLogAnalyse'   //登录日志分析
import  operLogAnalyse from '@/views/logManage/operLogAnalyse'   //操作日志分析

// 统计分析
import realTimeStatistic from '@/views/statistic/realTimeStatistic'   //实时概况
import transactionStatistic from '@/views/statistic/transactionStatistic'   //交易概况

// 统计分析
import providerRangliste from '@/views/statistic/providerRangliste'   //服务商排行
import designerRangliste from '@/views/statistic/designerRangliste'   //设计师排行
import dataAnalyse from '@/views/statistic/dataAnalyse'   //数据分析


Vue.use(Router)
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
let router =  new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            name: 'login',
            redirect: '/login',
            component: loginPage,
        },
        {
            path: '/login',
            name: 'login',
            component: loginPage,
        },
        {
            path: '/home',
            name: 'home',
            component: main,
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: homePage,
                    meta: {title: '首页'}
                },
                {
                    path: '/designerEnter',
                    name: 'designerEnter',
                    component: designerEnter,
                    meta: {title: '设计师入驻'}
                },
                {
                    path: '/facilitatorEnter',
                    name: 'facilitatorEnter',
                    component: facilitatorEnter,
                    meta: {title: '服务商入驻'}
                },
                {
                    path: '/merchantEnter',
                    name: 'merchantEnter',
                    component: merchantEnter,
                    meta: {title: '商家入驻'}
                },
                {
                    path: '/materialsAudit',
                    name: 'materialsAudit',
                    component: materialsAudit,
                    meta: {title: '材料管理'}
                },
                {
                    path: '/serverAudit',
                    name: 'serverAudit',
                    component: serverAudit,
                    meta: {title: '服务管理'}
                },
                {
                    path: '/productAudit',
                    name: 'productAudit',
                    component: productAudit,
                    meta: {title: '成品管理'}
                },
                {
                    path: '/demandAudit',
                    name: 'demandAudit',
                    component: demandAudit,
                    meta: {title: '需求管理'}
                },
                {
                    path: '/modelAudit',
                    name: 'modelAudit',
                    component: modelAudit,
                    meta: {title: '模型管理'}
                },
                {
                    path: '/worksAudit',
                    name: 'worksAudit',
                    component: worksAudit,
                    meta: {title: '成果管理'}
                },
                {
                    path: '/designAudit',
                    name: 'designAudit',
                    component: designAudit,
                    meta: {title: '平面设计管理'}
                },
                {
                    path: '/goodsAudit',
                    name: 'goodsAudit',
                    component: goodsAudit,
                    meta: {title: '商品管理'}
                },
                {
                    path: '/userPersonal',
                    name: 'userManager',
                    component: userManager,
                    meta: {title: '个人用户'}
                },
                {
                    path: '/userStaff',
                    name: 'userStaff',
                    component: userStaff,
                    meta: {title: '企业成员'}
                },
                {
                    path: '/userEnterprise',
                    name: 'userEnterprise',
                    component: userEnterprise,
                    meta: {title: '企业用户'}
                },
                {
                    path: '/printOrderList',
                    name: 'printOrderList',
                    component: printOrderList,
                    meta: {title: '打印订单'}
                },
                {
                    path: '/printOrderDetails/:uuid',
                    name: 'printOrderDetails',
                    component: printOrderDetails,
                    meta: { title: '打印订单详情' }
                },
                {
                    path: '/mallOrderList',
                    name: 'mallOrderList',
                    component: mallOrderList,
                    meta: {title: '商城订单'}
                },
                {
                  path: '/mallOrDetails/:orderBaseUuid',
                  name: 'mallOrDetails',
                  component: mallOrDetails,
                  meta: {title: '商城订单详情'}
                },
                {
                    path: '/designOrderList',
                    name: 'designOrderList',
                    component: designOrderList,
                    meta: {title: '设计订单'}
                },
                {
                    path: '/designOrderDetail/:uuid',
                    name: 'designOrderDetail',
                    component: designOrderDetail,
                    meta: {title: '设计订单详情'}
                },
                {
                    path: '/modelOrderList',
                    name: 'modelOrderList',
                    component: modelOrderList,
                    meta: {title: '模型订单'}
                },
                {
                  path: '/modelOrderDetails',
                  name: 'modelOrderDetails',
                  component: modelOrderDetails,
                  meta: {title: '模型订单详情'}
                },
                {
                    path: '/severOrderList',
                    name: 'severOrderList',
                    component: severOrderList,
                    meta: {title: '服务订单'}
                },
                {
                    path: '/serverOrderDetails/:uuid',
                    name: 'serverOrderDetails',
                    component: serverOrderDetails,
                    meta: {title: '服务订单详情'}
                },
                {
                    path: '/designOrderList1',
                    name: 'designOrderList1',
                    component: designOrderList1,
                    meta: {title: '先行支付订单'}
                },
                {
                    path: '/designOrderDetail1/:uuid',
                    name: 'designOrderDetail1',
                    component: designOrderDetail1,
                    meta: {title: '先行支付订单详情'}
                },
                // {
                //     path: '/softwareOrderList',
                //     name: 'softwareOrderList',
                //     component: softwareOrderList,
                //     meta: {title: '软件订单'}
                // },
                // {
                //   path: '/softwareOrderDetails',
                //   name: 'softwareOrderDetails',
                //   component: softwareOrderDetails,
                //   meta: {title: '软件订单详情'}
                // },
                {
                    path: '/complaintManagement',
                    name: 'complaintManagement',
                    component: complaintManagement,
                    meta: {title: '投诉管理'}
                },
                {
                    path: '/activityManagement',
                    name: 'activityManagement',
                    component: activityManagement,
                    meta: {title: '活动管理'}
                },
                {
                    path: '/signManagement',
                    name: 'signManagement',
                    component: signManagement,
                    meta: {title: '报名管理'}
                },
                {
                    path: '/worksManagement/:uuid?',
                    name: 'worksManagement',
                    component: worksManagement,
                    meta: {title: '作品管理'}
                },
                {
                  path: '/awardManagement/:uuid?',
                  name: 'awardManagement',
                  component: awardManagement,
                  meta: {title: '获奖作品'}
                },
                {
                  path: '/workReview',
                  name: 'workReview',
                  component: workReview,
                  meta: {title: '作品审核'}
                },
                {
                    path: '/judgesManagement',
                    name: 'judgesManagement',
                    component: judgesManagement,
                    meta: {title: '评委管理'}
                },
                {
                    path: '/leadershipManagement',
                    name: 'leadershipManagement',
                    component: leadershipManagement,
                    meta: {title: '领导管理'}
                },
                {
                    path: '/leadershipLibraryList',
                    name: 'leadershipLibraryList',
                    component: leadershipLibraryList,
                    meta: {title: '领导库'}
                },
                {
                    path: '/activityMatchList',
                    name: 'activityMatchList',
                    component: activityMatchList,
                    meta: {title: '活动比赛'}
                },
                {
                    path: '/judgesLibraryList',
                    name: 'judgesLibraryList',
                    component: judgesLibraryList,
                    meta: {title: '评委库'}
                },
                {
                    path: '/activityTemplate',
                    name: 'activityTemplate',
                    component: activityTemplate,
                    meta: {title: '模板库'}
                },
                {
                    path: '/activityStyle',
                    name: 'activityStyle',
                    component: activityTemplateStyle,
                    meta: {title: '皮肤库'}
                },
                {
                    path: '/evaluationManagement',
                    name: 'evaluationManagement',
                    component: evaluationManagement,
                    meta: {title: '评价管理'}
                },
                {
                    path: '/shopProviders',
                    name: 'shopProviders',
                    component: shopProviders,
                    meta: {title: '服务商管理'}
                },
                {
                    path: '/shopSettled',
                    name: 'shopSettled',
                    component: shopSettled,
                    meta: {title: '商家管理'}
                },
                {
                    path: '/designerManage',
                    name: 'designerManage',
                    component: designerManage,
                    meta: {title: '设计师管理'}
                },
                {
                    path: '/contractorManager',
                    name: 'contractorManager',
                    component: contractorManager,
                    meta: {title: '签约企业管理'}
                },
                {
                  path: '/categoryManagementList',
                  name: 'categoryManagementList',
                  component: categoryManagement,
                  meta: {title: '商品分类管理'}
                },
                {
                  path: '/category3D',
                  name: 'category3D',
                  component: category3D,
                  meta: {title: '商品规格管理'}
                },
                {
                  path: '/marketManagement',
                  name: 'marketManagement',
                  component: marketManagement,
                  meta: {title: '商品营销管理'}
                },
                {
                  path: '/category3DRecommend',
                  name: 'category3DRecommend',
                  component: category3DRecommend,
                  meta: {title: '商品推荐管理'}
                },
                {
                    path: '/shelveGoodsManagement',
                    name: 'shelveGoodsManagement',
                    component: shelveGoodsManagement,
                    meta: {title: '上架商品管理'}
                },
                {
                    path: '/designerLevelList',
                    name: 'designerLevelList',
                    component: designerLevelList,
                    meta: {title: '设计师级别管理'}
                },
                {
                    path: '/sysOperLogList',
                    name: 'sysOperLogList',
                    component: sysOperLogList,
                    meta: {title: '日志管理'}
                },
                {
                    path: '/integralTi',
                    name: 'integralTi',
                    component: integralTi,
                    meta: {title: '积分体系管理'}
                },
                {
                    path: '/integralSh',
                    name: 'integralSh',
                    component: integralSh,
                    meta: {title: '积分商品管理'}
                },
                {
                    path: '/integralPay',
                    name: 'integralPay',
                    component: integralPay,
                    meta: {title: '积分交易管理'}
                },
                {
                    path: '/collectActiveMage',
                    name: 'collectActiveMage',
                    component: collectActiveMage,
                    meta: {title: '集采活动管理'}
                },
                {
                    path: '/collectActiveStore',
                    name: 'collectActiveStore',
                    component: collectActiveStore,
                    meta: {title: '集采活动店铺'}
                },
                {
                    path: '/collectGoodsAudit',
                    name: 'collectGoodsAudit',
                    component: collectGoodsAudit,
                    meta: {title: '集采商品审核'}
                },
                {
                    path: '/collectGoodsMage',
                    name: 'collectGoodsMage',
                    component: collectGoodsMage,
                    meta: {title: '集采数据统计'}
                },
                {
                    path: '/collectOrderMage',
                    name: 'collectOrderMage',
                    component: collectOrderMage,
                    meta: {title: '集采订单管理'}
                },
                {
                    path: '/collectOrderDetails',
                    name: 'collectOrderDetails',
                    component: collectOrderDetails,
                    meta: {title: '集采订单管理详情'}
                },
                {
                    path: '/appletOrder',
                    name: 'appletOrder',
                    component: appletOrder,
                    meta: {title: '订单管理'}
                },
                {
                    path: '/appletInvoice',
                    name: 'appletInvoice',
                    component: appletInvoice,
                    meta: {title: '开票管理'}
                },
                {
                    path: '/appletCase',
                    name: 'appletCase',
                    component: appletCase,
                    meta: {title: '行业案例'}
                },
                {
                    path: '/appletExplain',
                    name: 'appletExplain',
                    component: appletExplain,
                    meta: {title: '产品说明'}
                },
                {
                    path: '/appletAbout',
                    name: 'appletAbout',
                    component: appletAbout,
                    meta: {title: '关于我们'}
                },
                {
                    path: '/appletMessage',
                    name: 'appletMessage',
                    component: appletMessage,
                    meta: {title: '留言管理'}
                },
                {
                    path: '/circleManager',
                    name: 'circleManager',
                    component: circleManager,
                    meta: {title: '创建圈子'}
                },
                {
                    path: '/circleAudit',
                    name: 'circleAudit',
                    component: circleAudit,
                    meta: {title: '圈子管理'}
                },
                {
                    path: '/dynamicAudit',
                    name: 'dynamicAudit',
                    component: dynamicAudit,
                    meta: {title: '动态管理'}
                },
                {
                    path: '/discountSetting',
                    name: 'discountSetting',
                    component: discountSetting,
                    meta: {title: '设计师折扣设置'}
                },
                {
                    path: '/serviceDiscountSetting',
                    name: 'serviceDiscountSetting',
                    component: serviceDiscountSetting,
                    meta: {title: '服务商折扣设置'}
                },
                {
                    path: '/commissionSet',
                    name: 'commissionSet',
                    component: commissionSet,
                    meta: {title: '佣金设置'}
                },
                {
                    path: '/integralActivitylManagement',
                    name: 'integralActivitylManagement',
                    component: integralActivitylManagement,
                    meta: {title: '活动管理'}
                },
                {
                    path: '/integralActivitylStore',
                    name: 'integralActivitylStore',
                    component: integralActivitylStore,
                    meta: {title: '活动店铺'}
                },
                {
                    path: '/integralGoodslManagement',
                    name: 'integralGoodslManagement',
                    component: integralGoodslManagement,
                    meta: {title: '积分商品管理'}
                },
                {
                    path: '/merchantsIntegralManagement',
                    name: 'merchantsIntegralManagement',
                    component: merchantsIntegralManagement,
                    meta: {title: '商家积分管理'}
                },
                {
                    path: '/userIntegralManagement',
                    name: 'userIntegralManagement',
                    component: userIntegralManagement,
                    meta: {title: '用户积分管理'}
                },
                {
                    path: '/integralOrderManagement',
                    name: 'integralOrderManagement',
                    component: integralOrderManagement,
                    meta: {title: '积分订单管理'}
                },
                {
                    path: '/integralOrderDetails',
                    name: 'integralOrderDetails',
                    component: integralOrderDetails,
                    meta: {title: '积分订单详情'}
                },
                {
                    path: '/appletOrderSx',
                    name: 'appletOrderSx',
                    component: appletOrderSx,
                    meta: {title: '订单管理'}
                },
                {
                    path: '/appletInvoiceSx',
                    name: 'appletInvoiceSx',
                    component: appletInvoiceSx,
                    meta: {title: '开票管理'}
                },
                {
                    path: '/appletCaseSx',
                    name: 'appletCaseSx',
                    component: appletCaseSx,
                    meta: {title: '行业案例'}
                },
                {
                    path: '/appletExplainSx',
                    name: 'appletExplainSx',
                    component: appletExplainSx,
                    meta: {title: '产品说明'}
                },
                {
                    path: '/appletAboutSx',
                    name: 'appletAboutSx',
                    component: appletAboutSx,
                    meta: {title: '关于我们'}
                },
                {
                    path: '/appletMessageSx',
                    name: 'appletMessageSx',
                    component: appletMessageSx,
                    meta: {title: '留言管理'}
                },
                {
                    path: '/systemLoginLog',
                    name: 'systemLoginLog',
                    component: systemLoginLog,
                    meta: {title: '登录日志管理'}
                },
                {
                    path: '/loginLogAnalyse',
                    name: 'loginLogAnalyse',
                    component: loginLogAnalyse,
                    meta: {title: '登录日志分析'}
                },
                {
                    path: '/operLogAnalyse',
                    name: 'operLogAnalyse',
                    component: operLogAnalyse,
                    meta: {title: '操作日志分析'}
                },
                {
                    path: '/realTimeStatistic',
                    name: 'realTimeStatistic',
                    component: realTimeStatistic,
                    meta: {title: '实时概况'}
                },
                {
                    path: '/transactionStatistic',
                    name: 'transactionStatistic',
                    component: transactionStatistic,
                    meta: {title: '交易概况'}
                },
                {
                    path: '/providerRangliste',
                    name: 'providerRangliste',
                    component: providerRangliste,
                    meta: {title: '服务商排行'}
                },
                {
                    path: '/designerRangliste',
                    name: 'designerRangliste',
                    component: designerRangliste,
                    meta: {title: '设计师排行'}
                },
                {
                    path: '/dataAnalyse',
                    name: 'dataAnalyse',
                    component: dataAnalyse,
                    meta: {title: '数据分析'}
                },
            ]
        },
    ]
})
router.beforeEach((to, from, next) => {
    let token = window.sessionStorage.getItem("api_access_token");
    if (to.name !== 'login' && !token) next({ name: 'login' })
    next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js